export const styles = {
  content: {
    textAlign: "center",
  },
  image: {
    width: "80px",
    height: "80px",
    mb: "16px",
  },
  heading: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "28px",
    color: "rgba(62, 63, 76, 1)",
    mb: "8px",
  },
  paragraph: {
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "rgba(47, 43, 61, 0.9)",
  },
};
